import { render } from "./Pisces.vue?vue&type=template&id=7dc8a556&scoped=true"
import script from "./Pisces.vue?vue&type=script&lang=js"
export * from "./Pisces.vue?vue&type=script&lang=js"

import "./Pisces.vue?vue&type=style&index=0&id=7dc8a556&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc8a556"]])

export default __exports__